import AutosizeInput from 'react-input-autosize';

import { FilterConfiguration } from './DataTable.types';

type DataTableSelectFilterProps = {
  filter: FilterConfiguration;
  value: string | number | null;
  onChange: (value: string | number | null) => void;
};

export function DataTableDateFilter({ filter, value, onChange }: DataTableSelectFilterProps) {
  return (
    <AutosizeInput
      type="date"
      // @ts-ignore
      onFocus={(event) => event.target.showPicker()}
      // @ts-ignore
      onClick={(event) => event.target.showPicker()}
      className="bg-white flex pl-3 pr-1"
      inputClassName="min-w-[8rem] outline-none"
      value={value ?? ''}
      onChange={(event) => {
        onChange(event.target.value);
      }}
    />
  );
}
